export default {
    APPLICATIONS:"applications/",
    CONFIRM_APPLICATION:"applications/otp/",
    APPLICATION_SCOPES:"applications/scopes"
};
